// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-tile {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.company-tile-image {
    align-items: center;
    display: flex;
    flex-direction: row;
    padding-right: 10px;
}

table.company-table {
    border-collapse: collapse;
    border-spacing: 0;
    display: table;
    border: 1px solid #ccc;
    background-color: #fff;
    margin: 10px;
  }
  table.company-table th,
  table.company-table td{
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
  }    
  table.company-table td:first-child {
    width: 35%;
    word-wrap: break-word;
    word-break: break-all;    
  }

  .mobile-company-tile{
    height: 100%;
    width: 100%;
    max-width: 70vw;
    max-height: -moz-fit-content;
    max-height: fit-content;
    min-height: 10vh;
    background-color: #334191;
    color: #fff;
    display: flex;
    flex-direction:row;
    align-items:center;
    justify-content: space-around;
  }
  table.expanded-table {
    height: 100%;
    width: 100%;
    max-width: 70vw;
    max-height: -moz-fit-content;
    max-height: fit-content;
    background-color: #334191;
    color: #fff;
    align-items:center;
    justify-content: space-around;
  }
  table.expanded-table th,
  table.expanded-table td{
    overflow-wrap: break-word;
    word-wrap: break-word;
  }    
  table.expanded-table td:first-child {
    width: 35%;
    word-wrap: break-word;
  }
  table.expanded-table td:nth-child(2) {
    word-wrap: break-word;
    word-break: break-all;    
  }`, "",{"version":3,"sources":["webpack://./src/css/components/CompanyTile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;;IAEE,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,qBAAqB;EACvB","sourcesContent":[".company-tile {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n}\r\n\r\n.company-tile-image {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding-right: 10px;\r\n}\r\n\r\ntable.company-table {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n    display: table;\r\n    border: 1px solid #ccc;\r\n    background-color: #fff;\r\n    margin: 10px;\r\n  }\r\n  table.company-table th,\r\n  table.company-table td{\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n    word-break: break-all;\r\n  }    \r\n  table.company-table td:first-child {\r\n    width: 35%;\r\n    word-wrap: break-word;\r\n    word-break: break-all;    \r\n  }\r\n\r\n  .mobile-company-tile{\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 70vw;\r\n    max-height: fit-content;\r\n    min-height: 10vh;\r\n    background-color: #334191;\r\n    color: #fff;\r\n    display: flex;\r\n    flex-direction:row;\r\n    align-items:center;\r\n    justify-content: space-around;\r\n  }\r\n  table.expanded-table {\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 70vw;\r\n    max-height: fit-content;\r\n    background-color: #334191;\r\n    color: #fff;\r\n    align-items:center;\r\n    justify-content: space-around;\r\n  }\r\n  table.expanded-table th,\r\n  table.expanded-table td{\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n  }    \r\n  table.expanded-table td:first-child {\r\n    width: 35%;\r\n    word-wrap: break-word;\r\n  }\r\n  table.expanded-table td:nth-child(2) {\r\n    word-wrap: break-word;\r\n    word-break: break-all;    \r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
